import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { OBJ_BG_COLORS, TAB_MENUS } from '../constants'
import { lockOrder, getOtherOrders } from '../Services/serviceAdmin'
import { getAllSlipInOrder, getRemainingAmount } from '../Services/servicePayment'
import { sortOrderByCreatedAt } from '../utils'
import Colors from '../../../constants/Colors'
import { formatPrice } from '../../../helpers/utils'
import { COUPON_TYPES } from '../../../constants/couponType'

const Card = ({ orders, order, setSlips, setOrders, setOrder, setOtherOrders, setRemainingAmount }) => {
  const dispatch = useDispatch()

  const selectedCard = async (hashId) => {
    dispatch({ type: 'loading_show' })
    let selectedOrder = {}
    let allOrder = []
    let remainAmount = undefined

    for (let v of orders) {
      v.id === hashId ? (selectedOrder = v) : allOrder.push(v)
    }

    if (selectedOrder?.status === 'CONFIRMED') {
      await lockOrder(selectedOrder?.id)
    }
    allOrder.sort(sortOrderByCreatedAt)
    allOrder.unshift(selectedOrder)

    const {
      userInfo: { userNo },
    } = selectedOrder || {}

    const others = await getOtherOrders(userNo)
    const allSlip = await getAllSlipInOrder(selectedOrder?.orderId)
    if (allSlip?.length > 0) {
      const remaining = await getRemainingAmount(allSlip[0]?.id)
      remainAmount = remaining?.remainingAmount
      if (remainAmount <= 0 && selectedOrder?.status !== 'SUCCESS') {
        allOrder = allOrder?.filter((v) => v.id !== order?.id)
      }
    }

    setSlips(allSlip)
    setRemainingAmount(remainAmount)
    setOrders(allOrder)
    setOrder(selectedOrder)
    setOtherOrders(others)
    dispatch({ type: 'loading_hide' })
  }

  return (
    <div>
      {orders?.map((order, i) => {
        const {
          id,
          orderId,
          totalPrice,
          status,
          createdAt,
          userInfo: { fullName, userNo },
          couponItem,
        } = order
        const atTime = new Date(createdAt).toLocaleString('TH-th')
        const bgColor = OBJ_BG_COLORS[status]
        const type = couponItem?.type
        return (
          <Container key={orderId} actived={i === 0} onClick={() => selectedCard(id)}>
            <Content>
              <CardBox>
                <h6>{orderId}</h6>
                <Status bgColor={bgColor}>{TAB_MENUS[status]}</Status>
              </CardBox>
              <CardBox>
                <p>{COUPON_TYPES[type] || '-'}</p>
              </CardBox>
              <CardBox style={{ marginBottom: '1rem' }}>
                <StyledNameText>{fullName}</StyledNameText>
                <StyledNameText>{userNo}</StyledNameText>
              </CardBox>
              <CardBox>
                <p>{atTime}</p>
                <p>{formatPrice(totalPrice)} บาท</p>
              </CardBox>
            </Content>
          </Container>
        )
      })}
    </div>
  )
}

export default Card

const Container = styled.div`
  padding: 0 ${({ actived }) => (actived ? 0 : '15px')};
`
const Content = styled.div`
  border-radius: 20px;
  cursor: pointer;
  padding: 10px;
  margin-bottom: 10px;
  background-color: ${Colors.WHITE};
`
const CardBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:first-child {
    margin-bottom: 14px;
  }
`
const Status = styled.div`
  padding: 10px;
  color: ${Colors.WHITE};
  border-radius: 20px;
  background-color: ${({ bgColor = Colors.ORANGE }) => bgColor};
`
const StyledNameText = styled.span`
  word-wrap: break-word;
  max-width: 50%;
`
